/**
 * "Failed to fetch" with no application frame (SLAPFIVE-FRONTEND-A62).
 *
 * The one production event was an inline script on the survey page (an image
 * onload handler injected into the HTML document) rejected through zone.js and
 * Sentry's own fetch wrapper. That is not an application fault. The same
 * message from our code, or from the Auth0 SDK called by our code, still has a
 * named function in a bundled .js file and must be reported.
 */

export interface FailedFetchFrame {
  filename?: string;
  function?: string;
  in_app?: boolean;
  module?: string;
}

export function isUnownedFailedFetch(
  message: string | null | undefined,
  frames: FailedFetchFrame[] | null | undefined
): boolean {
  const normalized = (message || '').trim().toLowerCase();
  if (normalized !== 'failed to fetch' && normalized !== 'typeerror: failed to fetch') {
    return false;
  }
  return !(frames || []).some(isApplicationFrame);
}

function isApplicationFrame(frame: FailedFetchFrame): boolean {
  if (frame.in_app === false) {
    return false;
  }
  const filename = frame.filename || '';
  if (!/\.m?js(?:[?#].*)?$/i.test(filename)) {
    return false;
  }
  if (/polyfills|node_modules|@sentry|\/vendor\//i.test(`${filename} ${frame.module || ''}`)) {
    return false;
  }
  const fn = (frame.function || '').trim();
  if (!fn || /^<?anonymous>?$/i.test(fn) || /zoneify|originalFetch|patchDelegate|proto\.<computed>/i.test(fn)) {
    return false;
  }
  return true;
}
